import { CheckboxField, EditResourceForm, TextField } from "~/components/Form";
import { useApiKey, useUpdateApiKey } from "~/domain/datastores";
import { makeApiKeyLocation, useApiKeyParams } from "~/paths";
import { selectData } from "~/utils";
import { EDITABLE_API_KEY_FIELDS, editApiKeySchema } from "../schemas";

export function ApiKeyEditForm() {
  const { apiKeyId } = useApiKeyParams();

  return (
    <EditResourceForm
      schema={editApiKeySchema}
      resourceName="API key"
      query={useApiKey(apiKeyId, { select: selectData })}
      editableFields={EDITABLE_API_KEY_FIELDS}
      mutation={useUpdateApiKey(apiKeyId)}
      resourceLocation={makeApiKeyLocation({ apiKeyId })}
    >
      {(control) => (
        <>
          <TextField control={control} name="name" required />
          <CheckboxField control={control} name="disabled" />
        </>
      )}
    </EditResourceForm>
  );
}
